/**
 * Application Entry Point
 * 
 * Main React application setup with routing, internationalization, and styling.
 * Configures the root App component with necessary providers and global setup.
 * 
 * Interactions:
 * - Uses BrowserRouter for client-side routing capabilities
 * - Integrates I18nextProvider for internationalization support
 * - Imports antd CSS for UI component styling
 * - Sets up Router component as main application component
 * - Renders to root DOM element for React application mounting
 */

import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import 'antd/dist/antd.min.css';

import Router from "./router";
import i18n from "./translation";

const App = () => (
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <Router />
    </I18nextProvider>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.getElementById("root"));
